import BaseController from './base_controller'

export default class extends BaseController {
  static targets = ['badge', 'btn']

  connect() {
    this._handleOutsideClick = (event) => {
      if (event.target.closest('[data-derived-index-target="badge"]') ||
          event.target.closest('.derived-index-popover')) return
      this.badgeTargets.forEach(badge => bootstrap.Popover.getInstance(badge)?.hide())
    }
    document.addEventListener('click', this._handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener('click', this._handleOutsideClick)
  }

  badgeTargetConnected(badge) {
    new bootstrap.Popover(badge, {
      trigger: 'click',
      html: true,
      container: 'body',
      placement: 'top',
      content: badge.dataset.derivedIndexContent,
      customClass: 'derived-index-popover'
    })
  }

  badgeTargetDisconnected(badge) {
    bootstrap.Popover.getInstance(badge)?.dispose()
  }

  toggle() {
    this.element.classList.toggle('derived-index-hidden')
    this.btnTarget.classList.toggle('selected')
  }
}
